import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LabadminService } from 'src/app/labadmin/labadmin.service';
import { saveAs as importedSaveAs } from "file-saver";
import { FormBuilder, Validators } from '@angular/forms';
import { SelectionModel } from '@angular/cdk/collections';
import { MatSnackBar } from '@angular/material/snack-bar';
import { StaticMessages } from '../../utility/MessageConstants';

@Component({
  selector: 'app-bulk-upload-pop-up',
  templateUrl: './bulk-upload-pop-up.component.html',
  styleUrls: ['./bulk-upload-pop-up.component.scss']
})
export class BulkUploadPopUpComponent implements OnInit {
  errorMessage: string = ''
  uploadedFile : any
  fromManageLots : boolean = false
  panelSelectionModel = new SelectionModel(true, [])
  Panels: any[];
  DeviationType = []
  originalDeviationTypeList: any[] = [];
  deviationTypeFilter = []
  showLoader : boolean = false
  enableCatorization : boolean = false
  categoryOptions: any = [];

  constructor(
    private _labAdminService: LabadminService,
    private _dialogRef: MatDialogRef<BulkUploadPopUpComponent>,
    private _fb: FormBuilder,
    private _snackbar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public config: any,
  ) { }

  lotExcelGenerationForm = this._fb.group({
    caseType : ['', [Validators.required]],
    panel : ['', [Validators.required]],    
    deviationType : ['', [Validators.required]],
    setDiffMinAndMax : [ false ]
  })

  get lot_controls() {
    return this.lotExcelGenerationForm.controls;
  }

  ngOnInit(): void {
    this.DeviationType = this.config?.deviationType ?? [];
    this.originalDeviationTypeList = structuredClone(this.DeviationType);
    this.categoryOptions = this.config?.categoryOptions ?? [];
    this.fromManageLots = this.config.type === 'lots';
    this.onCaseTypeChange()
    if (this.config?.caseTypes?.length === 1) {
      this.lotExcelGenerationForm.controls.caseType.patchValue(this.config.caseTypes[0].CaseTypeDisplayName);
    }
  }
  onCaseTypeChange() {
    this.lotExcelGenerationForm.get('caseType')?.valueChanges.subscribe(value => {
      const casetypeInternal = this.getCaseTypeForDependency(value);
      this.panelSelectionModel.clear();
      this.Panels = [];
      if (casetypeInternal)
        this.getPanels(casetypeInternal);
        this.filterDeviationType(casetypeInternal);
    });
  }

  onDrop(files: any) {
    if(files.length > 1){
      this.errorMessage = 'Error: Please Upload a Single File.'
    }
    else this.validateFile(files[0]);
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    this.validateFile(input.files[0]);
  }

  validateFile(file){
   this.clearSelection()
    const regexp = new RegExp('^xlsx$')
    var ext = /[^\.]*$/.exec(file.name);
    if ((ext && !regexp.test(ext[0]))) {
      this.errorMessage = 'Error: File Format Not Supported'
    }
    this.uploadedFile = file
    this.uploadedFile.calculatedSize = `${Math.round(file.size / 1024)}KB`
  }

  downloadSampleTemplate(){
    return this._labAdminService.GetSampleTemplates(this.config.type, this._labAdminService.deploymentKey).subscribe({
      next: (res) => {
        let filename = 'UploadBulkFacilityUsers.xlsx'
        if(this.config.type === 'labusers') filename = 'UploadBulkLabUsers.xlsx'
        else if(this.config.type ==='referringphy') filename = 'UploadBulkReferringPhysicians.xlsx'
        else if(this.config.type ==='physician') filename = 'UploadBulkProviders.xlsx'

        importedSaveAs(res, filename)
      },
      error: (err) => {
        this.showLoader = false;
        console.error('Download template error:', err);
        // this._snackbar.open('Failed to download template. Please try again.', 'Close');
        this._snackbar?.open('Failed to download template. Please try again.', null, {
          panelClass: ['failure-snackbar']
        });
      }
    })
  }

  getPanels(casetype: string) {

    if(!casetype) {
      return;
    }

    let testCategory = this.checkCategorySelected() ? 'Molecular QC' : 'All';
    let isqc = true;

    this._labAdminService.GetPanels(this._labAdminService.deploymentKey, this.config?.primaryLabAccountId, casetype, isqc, testCategory)
      .subscribe({
        next: (response: Panel[]) => {
          this.Panels = response;
          this.enableCatorization = !this.Panels.every((i: Panel) => i.Category.toLowerCase() == 'others')
        },
        error: (err) => {
          // this._snackbar.open('Something went wrong','Close')
          this._snackbar?.open('Something went wrong', null, {
            panelClass: ['failure-snackbar']
          });
          console.error('Error:', err);
        }
      });
  }

  clearSelection(){
    this.uploadedFile = null
    this.errorMessage = ''
  }

  onUploadClick(){
    this._dialogRef.close(this.uploadedFile)
  }

  generateAndDownloadTemplate(){
    try{
      let selectedCaseType = this.getCaseTypeForDependency(this.lotExcelGeneration.caseType);
      this.showLoader = true
      let obj = {
        "Casetype" : this.config?.caseTypes.find((j) => j.Casetype === selectedCaseType).CaseTypeDisplayName,
        "DerivationType" : this.lotExcelGeneration.deviationType,
        "SetDifferentMinMax" : this.lotExcelGeneration.setDiffMinAndMax,
        "Levels": this.config.level.filter((x) => x.AttributeContext == selectedCaseType)?.map((j) => j.AttributeValue),
        "OrganizationID" : this._labAdminService.organizationId,
        "Panels" : this.Panels.filter((k) => this.panelSelectionModel.selected.includes(k.OrderCodeID)).map((j) => ({'ProcedureName' : j.ProcedureName, 'OrderCodeID' : j.OrderCodeID})),
        "SpecimenTypes" : this.config.specimenType.map((j) => j.DisplayName),
        "LabLocations" : this.config.labLocation.map((j) => j.displayname),
        "Flags" : this.config.flags.map((j) => j.Flag),
        "Classifications" : this.config.classification.map((j) => j.AttributeValue),
        "templateFile" : this.getTemplatePath(),
        "HiddenFields" : this.getHiddenFileds()        
      }
     this._labAdminService.generateXlTemplate(obj).subscribe({
        next: (res) =>{
           importedSaveAs(res, "Manage Lot.xlsx")
           this.showLoader = false
        },
        error : (err) => {
          this.showLoader = false
          console.error(err)
          // this._snackbar.open(StaticMessages.ON_ERROR, StaticMessages.CLOSE)
          this._snackbar?.open(StaticMessages.ON_ERROR, null, {
            panelClass: ['failure-snackbar']
          });
        }
      })
    }catch{
      this.showLoader = false
    }
    
  }

  get lotExcelGeneration(){
    return this.lotExcelGenerationForm.value
  }

  getTemplatePath(){
    let selectedCaseType = this.getCaseTypeForDependency(this.lotExcelGeneration.caseType);
    const configuration = this.config.displayFields.filter((j) => j.AttributeContext == selectedCaseType)
    if (configuration[0]?.AttributeContextId3) {
      const columns = JSON.parse(configuration[0]?.AttributeContextId3)
      return columns?.Template ?? ''
    }
  }

  getHiddenFileds() {
    let selectedCaseType = this.getCaseTypeForDependency(this.lotExcelGeneration.caseType);
    let hiddenFields = []
    const configuration = this.config.displayFields.filter((j) => j.AttributeContext == selectedCaseType)
    if (configuration[0]?.AttributeContextId3) {
      const columns = JSON.parse(configuration[0]?.AttributeContextId3)
      if (columns?.Fields) {
        for (const [key, value] of Object.entries<any>(columns.Fields)) {
          if (key.toLowerCase() == 'totalunits' && value.toLowerCase() == 'hide') {
            hiddenFields.push(key)
          }
        }
      }
    }
    return hiddenFields;
  }

  filterDeviationType(casetype: string){
    if(this.DeviationType.length > 0){
      // const isOrgLevelConfigPresent = this.DeviationType.some(i => i.Organizationid == Number(this._labAdminService.organizationId) && i.casetype == casetype)

      this.deviationTypeFilter = this.DeviationType.filter(i => i.casetype == casetype)
      //isOrgLevelConfigPresent ? this.DeviationType.filter(i => i.Organizationid == Number(this._labAdminService.organizationId) && i.casetype == casetype) : this.DeviationType.filter(i => i.Organizationid == -1 && i.casetype == casetype)

      if(this.deviationTypeFilter.length == 1){
        this.lotExcelGenerationForm.controls.deviationType.setValue(this.deviationTypeFilter[0].type)
      }

    }
  }
  
  checkCategorySelected() {
    let caseTypeValue = this.lot_controls?.caseType?.value;
    if ((this.categoryOptions || []).find((item: any) => item?.Value === caseTypeValue)) {
      return true;
    } else {
      return false;
    }
  }

  generateAndDownloadMolecularTemplate() {
    this._snackbar?.open('Template not available. Please contact your administrator.', null, {
      panelClass: ['warning-snackbar']
    });
  }

  getCaseTypeForDependency(formOrFilterValue?: string): string {
    const value = (formOrFilterValue ?? '').trim();
    if (!value) return '';
    const valueNorm = value.toLowerCase();
    const found = this.config?.caseTypes?.find(
      (ct) =>
        (ct.CaseTypeDisplayName?.trim().toLowerCase() === valueNorm) ||
        (ct.Casetype?.trim().toLowerCase() === valueNorm)
    );
    return found?.Casetype ?? '';
  }
}
export interface Panel {
  ProcedureName: string
  Sequence: number
  ProcedureCode: string
  OrderCodeID: number
  Category: string
}
